export const WHATSAPP_URL =
    "https://chat.whatsapp.com/DEo7hkAxMOv9GguqOhd4w4?s=cl&p=i&ilr=1";

export const STRIPE_LINKS = {
    monthly: "https://buy.stripe.com/6oU9ATayFa9Ze3k9RDcbC03",
    annual: "https://buy.stripe.com/8x28wPayF2Hx6AS8NzcbC02",
};

// Editable placeholders — replace when available
export const LEGAL_LINKS = {
    privacy: "#privacidad",
    terms: "#condiciones",
    cookies: "#cookies",
    legal: "#aviso-legal",
};

export const open = (url) => {
    if (url) window.open(url, "_blank", "noopener,noreferrer");
};

export const trackAndOpen = (url, event, params = {}) => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        try {
            window.fbq("track", event, params);
        } catch (_) {
            /* pixel optional */
        }
    }
    open(url);
};
